export const ComoFuncionaSection = () => {
  const passos = [
    {
      id: "passo-embarque",
      icon: "🚤",
      bgColor: "bg-[#002776]",
      title: "Embarque na Caravela",
      description: "Você embarca em Porto Belo em uma caravela confortável e instagramável. Café da manhã servido a bordo enquanto navegamos.",
      highlight: null
    },
    {
      id: "passo-navegacao",
      icon: "🌊",
      bgColor: "bg-[#002776]",
      title: "Navegação pelas paisagens",
      description: "Passamos por praias paradisíacas como Araçá e Caixa d'Aço, navegando até a ponta de Bombinhas. Paisagens incríveis e muitas fotos!",
      highlight: null
    },
    {
      id: "passo-snorkeling",
      icon: "🤿",
      bgColor: "bg-[#009C3B]",
      title: "Parada para banho e snorkeling",
      description: "Paramos no melhor ponto para snorkeling.",
      highlight: "Não precisa saber nadar!",
      descriptionEnd: "Você recebe roupa de neoprene que faz o corpo flutuar naturalmente."
    },
    {
      id: "passo-ritmo",
      icon: "😎",
      bgColor: "bg-[#002776]",
      title: "Aproveite no seu ritmo",
      description: "Quer mergulhar? Vai! Prefere relaxar no barco? Também pode. Você aproveita do seu jeito, sem pressa.",
      highlight: null
    },
    {
      id: "passo-sorteio",
      icon: "🎁",
      bgColor: "bg-[#FFDF00]",
      title: "Sorteio de prêmios",
      description: "Todo passeio termina com um sorteio especial! Brindes variam: mergulho com cilindro, hospedagem, descontos e muito mais.",
      highlight: null
    }
  ];

  return (
    <section 
      className="py-12 md:py-16 bg-gradient-to-b from-white to-gray-100"
      data-testid="como-funciona-passeio-section"
    >
      <div className="max-w-4xl mx-auto px-4">
        {/* Título */}
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl text-[#002776] mb-3">
            COMO FUNCIONA O PASSEIO
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Do embarque ao mergulho — veja como é viver essa experiência no mar de Porto Belo
          </p>
        </div>
        
        {/* Passos */}
        <div className="space-y-6">
          {passos.map((passo, i) => (
            <div key={passo.id} className="flex items-start gap-4 bg-white rounded-2xl p-5 shadow-lg border border-gray-100">
              <div className={`flex-shrink-0 w-14 h-14 ${passo.bgColor} rounded-xl flex items-center justify-center`}>
                <span className="text-2xl">{passo.icon}</span>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-bold text-[#009C3B] bg-[#009C3B]/10 px-2 py-0.5 rounded-full">PASSO {i + 1}</span>
                </div>
                <h3 className="font-bold text-lg text-[#002776] mb-1">{passo.title}</h3>
                <p className="text-gray-600 text-sm">
                  {passo.description}
                  {passo.highlight && (
                    <>
                      {" "}<strong className="text-[#009C3B]">{passo.highlight}</strong>{" "}
                    </>
                  )}
                  {passo.descriptionEnd}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Duração */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 bg-[#002776]/10 rounded-full px-5 py-3">
            <span className="text-xl">⏱</span>
            <span className="font-bold text-[#002776]">Duração média: 3 a 4 horas</span>
          </div>
        </div>
        
        {/* Frase de fechamento */}
        <div className="mt-8 text-center bg-gradient-to-r from-[#002776] to-[#003399] rounded-2xl p-6">
          <p className="text-white text-lg md:text-xl font-medium italic">
            "Uma experiência completa, segura e diferente de tudo que você já viveu no mar."
          </p>
        </div>
      </div>
    </section>
  );
};

export default ComoFuncionaSection;
